import loadScript from 'lib/load-script';

type VendorConsents = {
    consentedVendors: Array<{ _id: string }>;
};

const GOOGLE_ANALYTICS_ID = '5e542b3a4cd8884eb41b5a72';

const hasConsent = (vendorConsents: VendorConsents, ID: string) =>
    vendorConsents.consentedVendors.some((vendor: { _id: string }) => vendor._id === ID);

const getVendorsData = function () {
    __tcfapi(
        'getCustomVendorConsents',
        2,
        (vendorConsents: VendorConsents, successForConsent: boolean) => {
            if (successForConsent) {
                const hasGoogleAnalyticsConsent = hasConsent(vendorConsents, GOOGLE_ANALYTICS_ID);

                if (hasGoogleAnalyticsConsent) {
                    setTimeout(() => {
                        loadScript('/bff/join-plans/analytics.js', 'analytics');
                    }, 100);
                }
            }
        }
    );
};

export function handleCookieConsent(
    tcData: { gdprApplies: boolean; eventStatus: string; listenerId: string },
    success: boolean
) {
    if (success) {
        if (
            !tcData.gdprApplies &&
            (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'cmpuishown')
        ) {
            // non-gdpr countries
            // set all cookies allowed
            // @TODO add CCPA + Brazil
            setTimeout(() => {
                loadScript('/bff/join-plans/analytics.js', 'analytics');
            }, 400);
        } else if (tcData.gdprApplies) {
            const cookieContainer: HTMLElement | null =
                document.querySelector('.cookie-notification');

            if (cookieContainer) {
                cookieContainer.style.display = 'none';
            }
            // we call script on each page load, if script loaded - it won't load again
            getVendorsData();
        }
    }

    return tcData.listenerId;
}

export const onUseCookieConsentEvent = () => {
    const listenerId = __tcfapi?.('addEventListener', 2, handleCookieConsent);

    return () => {
        __tcfapi?.('removeEentListener', 2, null, listenerId);
    };
};

function displayPM(event: Event) {
    event.preventDefault();

    try {
        //@ts-ignore
        window._sp_.gdpr.loadPrivacyManagerModal();
    } catch (error) {
        window.location.href = 'https://bumble.com/cookie-policy';
    }
}

export const onUsePrivacyManagerHandler = () => {
    const privacyManagerEl = document.querySelector('.js-manage-cookies');

    if (privacyManagerEl) {
        privacyManagerEl.addEventListener('click', displayPM);
    }

    return () => {
        if (privacyManagerEl) {
            privacyManagerEl.removeEventListener('click', displayPM);
        }
    };
};
